import _slicedToArray from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
export var makeAddressFromGeocoderResult = function makeAddressFromGeocoderResult(r) {
  // https://developers.google.com/maps/documentation/javascript/geocoding#GeocodingAddressTypes
  var _r$address_components = r.address_components.filter(function (c) {
    return c.types.includes('street_number');
  }),
      _r$address_components2 = _slicedToArray(_r$address_components, 1),
      street_number = _r$address_components2[0];

  var _r$address_components3 = r.address_components.filter(function (c) {
    return c.types.includes('route');
  }),
      _r$address_components4 = _slicedToArray(_r$address_components3, 1),
      route = _r$address_components4[0];

  var _r$address_components5 = r.address_components.filter(function (c) {
    return c.types.includes('locality');
  }),
      _r$address_components6 = _slicedToArray(_r$address_components5, 1),
      locality = _r$address_components6[0];

  var _r$address_components7 = r.address_components.filter(function (c) {
    return c.types.includes('postal_code');
  }),
      _r$address_components8 = _slicedToArray(_r$address_components7, 1),
      postal_code = _r$address_components8[0];

  var _r$address_components9 = r.address_components.filter(function (c) {
    return c.types.includes('country');
  }),
      _r$address_components10 = _slicedToArray(_r$address_components9, 1),
      country = _r$address_components10[0]; // UK addresses can be missing locality and have postal_town instead.


  if (!street_number || !route || !locality || !postal_code || !country) return r.formatted_address;
  var retval = "".concat(street_number.short_name, " ").concat(route.short_name, ", ").concat(locality.long_name);

  var _r$address_components11 = r.address_components.filter(function (c) {
    return c.types.includes('administrative_area_level_1');
  }),
      _r$address_components12 = _slicedToArray(_r$address_components11, 1),
      administrative_area_level_1 = _r$address_components12[0];

  if (administrative_area_level_1) retval = "".concat(retval, ", ").concat(administrative_area_level_1.short_name);
  retval = "".concat(retval, " ").concat(postal_code.short_name, ", ").concat(country.long_name);
  return retval;
};